import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

export const initBenaviSwiper = () => {
  // benavi-swiper1 が存在しなければ初期化しない
  const swiper1El = document.querySelector('.benavi-swiper1');
  if (!swiper1El) return;

  // KV Swiper (fade)
  const swiper1 = new Swiper('.benavi-swiper1', {
    modules: [Autoplay, EffectFade, Pagination],
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    grabCursor: true,
    allowTouchMove: false,
    simulateTouch: false,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    pagination: { el: '.benavi-pagination1', clickable: true },
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    roundLengths: true,
    speed: 400,
  });

  // disclaimerの監視
  const disclaimerObserver = new MutationObserver(() => {
    const disclaimer = document.getElementById('disclaimer');
    const bullets = document.querySelectorAll('.benavi-pagination1 .swiper-pagination-bullet');

    if (disclaimer) {
      swiper1.autoplay.stop();
      bullets.forEach(bullet => bullet.classList.remove('swiper-pagination-bullet-active'));
    } else {
      bullets[0]?.classList.add('swiper-pagination-bullet-active');
      swiper1.autoplay.start();
      disclaimerObserver.disconnect();
    }
  });

  disclaimerObserver.observe(document.body, { childList: true, subtree: true });

  if (document.getElementById('disclaimer')) {
    const bullets = document.querySelectorAll('.benavi-pagination1 .swiper-pagination-bullet');
    swiper1.autoplay.stop();
    bullets.forEach(bullet => bullet.classList.remove('swiper-pagination-bullet-active'));
  }

  // Information Swiper は initInfoSwiper（infoSwiper.js）に分離

  // Movie Modal Swiper (fade)
  const swiper3El = document.querySelector('.benavi-swiper3');
  if (!swiper3El) return;

  const swiper3 = new Swiper('.benavi-swiper3', {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
      stopOnLastSlide: true,
    },
    allowTouchMove: false,
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    speed: 800,
    pagination: false,
    navigation: false,
    on: {
      slideChange: function () {
        if (this.activeIndex === this.slides.length - 1) this.autoplay.stop();
      },
    },
  });

  // モーダルの監視
  const movieModal = document.querySelector('.movie-modal');
  const movieObserver = new MutationObserver(() => {
    if (movieModal.classList.contains('-active')) {
      swiper3.slideTo(0, 0);
      swiper3.autoplay.start();
    } else {
      swiper3.autoplay.stop();
    }
  });

  if (movieModal) {
    movieObserver.observe(movieModal, { attributes: true, attributeFilter: ['class'] });
  }
};
